import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import ContentCard from "@/components/ContentCard";
import BackLink from "@/components/BackLink";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const SLUG_MAP = {
  "hjalp-i-vardagen": { rubrik: "Hjälp i vardagen", intro: "Praktisk hjälp i vardagen. Behöver du en hand \u2013 eller har du en att räcka ut? Ved, skjuts, handräckning och annat som gör livet lättare." },
  "hand-mot-hand": { rubrik: "Hand mot hand", intro: "Byt tjänster och kunskap utan pengar. Jag fixar din dator \u2013 du hjälper mig med trädgården. Här möts man på lika villkor." },
  "kop-salj": { rubrik: "Köp & sälj lokalt", intro: "Köp, sälj eller skänk saker lokalt. Allt granskas av vårt team. Tryggt, nära och utan mellanhänder." },
};

export default function AnslagCategory() {
  const { slug } = useParams();
  const [anslag, setAnslag] = useState([]);
  const cat = SLUG_MAP[slug];

  useEffect(() => {
    if (cat) {
      axios.get(`${API}/anslag`, { params: { rubrik: cat.rubrik } }).then(r => setAnslag(r.data)).catch(() => {});
    }
  }, [slug, cat]);

  if (!cat) return <div className="max-w-5xl mx-auto px-4 py-14"><p>Rubriken hittades inte.</p></div>;

  return (
    <div data-testid="anslag-category-page" className="max-w-5xl mx-auto px-4 sm:px-6 py-10 sm:py-14">
      <BackLink to="/anslagstavla" label="Anslagstavla" />
      <h1 className="font-heading text-3xl sm:text-4xl font-medium text-ink mb-3">{cat.rubrik}</h1>
      <p className="text-lg text-muted-foreground mb-8 max-w-2xl">{cat.intro}</p>

      {anslag.length === 0 ? (
        <div data-testid="empty-state" className="bg-bone-alt rounded-sm p-8 text-center">
          <p className="text-lg text-muted-foreground mb-4">Här är det tomt just nu \u2013 men det kan du ändra på.</p>
          <Link to="/skicka-anslag" className="inline-flex items-center bg-falu hover:bg-falu-hover text-white font-body font-medium text-base px-5 py-3 rounded-md transition-colors no-underline">
            Skicka in anslag
          </Link>
        </div>
      ) : (
        <div className="flex flex-col gap-4">
          {anslag.map((item) => (
            <ContentCard key={item.id} item={{ ...item, typ: "anslag" }} />
          ))}
        </div>
      )}

      <div className="mt-10 bg-bone-alt rounded-sm p-6">
        <p className="text-base text-muted-foreground mb-3">Vill du lägga upp något här? Skicka in till oss.</p>
        <Link
          to={`/skicka-anslag?rubrik=${encodeURIComponent(cat.rubrik)}`}
          data-testid="cta-category-skicka"
          className="inline-flex items-center bg-falu hover:bg-falu-hover text-white font-body font-medium text-base px-5 py-3 rounded-md transition-colors no-underline"
        >
          Skicka in anslag
        </Link>
      </div>

      <p className="mt-8 text-sm text-muted-foreground">Alla anslag granskas av vårt lokala team.</p>
    </div>
  );
}
